import { ExperienceEntity, ExperienceEntityTree, ExperienceEntityType } from './types';

export const getInitials = (label: string) =>
  label
    .split(' ')
    .slice(0, 2)
    .map(word => word.charAt(0))
    .join('');

export const recursiveGetOfType = (
  experienceEntityTree: ExperienceEntityTree,
  experienceEntityType: ExperienceEntityType,
): ExperienceEntity[] => {
  if (experienceEntityTree.experienceEntity.experienceEntityType === experienceEntityType) {
    return [experienceEntityTree.experienceEntity];
  }

  return experienceEntityTree.children.flatMap((child: ExperienceEntityTree) =>
    recursiveGetOfType(child, experienceEntityType),
  );
};

export const recursiveFindEntity = (
  experienceEntityTree: ExperienceEntityTree,
  experienceEntityId: string,
): ExperienceEntityTree | undefined => {
  if (experienceEntityTree.experienceEntity.experienceEntityId === experienceEntityId) {
    return experienceEntityTree;
  }

  return experienceEntityTree.children
    .map((child: ExperienceEntityTree) => recursiveFindEntity(child, experienceEntityId))
    .find(Boolean);
};
